import { toast } from "react-toastify";

const doToast = (message, type, customOptions = {}) => {
  let bgColor;
  let color;
  if (type?.toLowerCase() === "success") {
    bgColor = "#3F826D";
  } else if (type?.toLowerCase() === "error") {
    bgColor = "#FF4746";
  } else if (type?.toLowerCase() === "warn") {
    bgColor = "#E2A91B";
  }
  const options = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    style: { backgroundColor: bgColor, color: color },
    ...customOptions
  };
  if (type) {
    toast[type](message ?? "", options);
  } else {
    toast.success(message ?? "", options);
  }
};

export default doToast;
